import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { CallState } from "redmond";

import { IAvailabilityErrorModalOwnProps, ShopErrorModal } from "./component";
import {
  getExperiencesNoAvailability,
  getExperiencesSearchLocation,
  getExperiencesShopCallState,
  getExperiencesShopOptionsCallState,
  getSelectedDate,
  getSelectedExperienceId,
} from "../../reducer/selectors";
import { IStoreState } from "../../../../reducers/types";
import { fetchExperienceShop } from "../../../../api/v0/shop/fetchExperiencesShop";
import { getFromDate, getUntilDate } from "../../../search/reducer";

const mapStateToProps = (state: IStoreState) => ({
  hasError:
    getExperiencesShopCallState(state) === CallState.Failed ||
    getExperiencesShopOptionsCallState(state) === CallState.Failed,
  noAvailability: getExperiencesNoAvailability(state),
  locationLabel: getExperiencesSearchLocation(state),
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  selectedExperienceId: getSelectedExperienceId(state),
  selectedDate: getSelectedDate(state),
});

const mapDispatchToProps = {
  fetchExperienceShop,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ShopErrorModalConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedShopErrorModal = withRouter(
  connector(ShopErrorModal),
) as React.ComponentType<IAvailabilityErrorModalOwnProps>;
